var _class;
/*
 *                     NOTICE
 *            COPYRIGHT 2021 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { BaseRCmp } from "abreact/incubator/ui/component/BaseRCmp";
import { ReactUtils } from "abreact/incubator/ui/utils/ReactUtils";
import { AbVBox } from "abreact/layout/AbVBox";
import { AbBusyIndicator, BusyIndicatorSize } from "abreact/progress/AbBusyIndicator";
import { AbProgress } from "abreact/progress/AbProgress";
import { AbProgressBar } from "abreact/progress/AbProgressBar";
import { ArrayUtils } from "abweb/utils/ArrayUtils";
import { observer } from "mobx-react";
import * as React from "react";
export let AbProgressIndicator = observer(_class = class AbProgressIndicator extends BaseRCmp {
  render() {
    const showProgressBar = this.props.pctComplete !== undefined || this.props.showProgressBounceIfPctCompleteUndefined;
    return /*#__PURE__*/React.createElement(AbVBox, ReactUtils.componentProps("ab-progress"), !showProgressBar && /*#__PURE__*/React.createElement(AbBusyIndicator, {
      size: this.props.size ?? BusyIndicatorSize.SMALL,
      delay: 0
    }), showProgressBar && /*#__PURE__*/React.createElement(AbProgressBar, {
      value: this.props.pctComplete
    }), !(ArrayUtils.isStringArray(this.props.message) && this.props.message.length === 0) && /*#__PURE__*/React.createElement("div", {
      className: ReactUtils.classNamesString(["ab-progress-message", ArrayUtils.isStringArray(this.props.message) && "ab-progress-multiline"])
    }, AbProgress.renderProgressContent(this.props.message)));
  }
}) || _class;
//# sourceMappingURL=AbProgressIndicator.js.map
